import { useContext } from 'react';
import StepperContext from 'src/store/stepper-context';
import InfoModal from 'src/components/modal/InfoModal';

/**
 * StepInfoModal is a component that renders an modal with information about the current step in a multi-step process.
 *
 * @returns {ReactElement} - A React element that renders the InfoModal component with the information about the current step.
 */
const StepInfoModal = () => {
  const { infoModalController, infoModalContent } = useContext(StepperContext);
  return (
    <InfoModal
      content={infoModalContent}
      onClose={infoModalController.closeModal}
      open={infoModalController.open}
    />
  );
};

export default StepInfoModal;
